import { Card, CardTag, Css } from "@homebound/beam";
import { PRODUCT_FALLBACK_IMG_URL } from "src/utils/constants";
import { ProductCard_LocationFragment, ProductCard_MaterialVariantFragment } from "./ProductCard.generated";

type ProductCardProps = {
  /** The product to show. Nullable so callers can pass a project item's variant as-is. */
  materialVariant: ProductCard_MaterialVariantFragment | null | undefined;
  /** The project item's location, i.e. "Kitchen", to tell apart two of the same product. */
  location?: ProductCard_LocationFragment;
  tag?: CardTag;
  bordered?: boolean;
};

/** The product thumbnail + brand/name/location shown wherever the swap workflow lists a product. */
export function ProductCard(props: ProductCardProps) {
  const { materialVariant, location, tag, bordered } = props;
  return (
    <Card
      imgSrc={materialVariant?.featuredImage?.asset?.previewUrl ?? PRODUCT_FALLBACK_IMG_URL}
      title={materialVariant?.displayName ?? ""}
      subtitle={materialVariant?.listing.brand?.name ?? materialVariant?.listing.name ?? ""}
      detailContent={location && <span css={Css.xs.gray700.$}>{location.displayLocationPath}</span>}
      type="list"
      fullWidth
      bordered={bordered}
      tag={tag}
    />
  );
}
